import { Box, Button, Typography, styled } from "@mui/material"

export const ModalHeader = styled(Box)({
    width: "100%",
    height: "30px",
    display: "flex",
    justifyContent: "flex-end",
})

export const ButtonContainer = styled(Box)({
    alignSelf: "flex-end",
    justifySelf: "flex-end",
    display: "flex",
    height: "fit-content",
    justifyContent: "center",
    width: "100%",
    // border: "1px solid red",
    marginTop: "auto",
    // padding: "0 20px"
})

export const CancelButton = styled(Box)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "138px",
    height: "40px",
    borderRadius: "4px",
    outline: "1px solid #4A79E7",
    cursor: "pointer"
})

export const ConfirmButton = styled(Box)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "138px",
    height: "40px",
    borderRadius: "4px",
    marginLeft: "38px",
    backgroundColor: "#4A79E7",
    cursor: "pointer"
})